<template>
  <div class="activityIndex">
    <heads></heads>
    <!-- <el-carousel trigger="click" height="500px" indicator-position="none" v-loading="bannerLoading">
      <el-carousel-item v-for="(item,index) in bannerArray" :key="index">
        <img :src="item.path" class="ban-img" />
      </el-carousel-item>
    </el-carousel> -->

    <div class="container">
      <div class="textnav">
        <!-- <span v-if="item.iconLinkStatus === 0" -->
        <span
          v-for="(item,index) in lineIconArray"
          :key="index"
          v-if="item.iconLinkStatus === 0"
          class="commonTabStyle"
          :class="nav==item.id?'nac-active':'nac' "
          @click="getNav(item.id)"
        >{{item.iconContent}}</span>
      </div>

      <!-- <transition name="fade"> -->
      <div class="content" v-loading="loading">
        <!-- <transition-group appear tag="ul" name="fade"> -->
        <div
          class="rotation-right"
          v-for="(item,index) in pageArray"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="trans-img">
            <img :src="item.linePictureUrl" class="right-img" />
          </div>

          <div class="padd-info">
            <div class="right-infoitem">{{item.lineTitile}}</div>
            <div class="info-describe">{{item.lineAbstract}}</div>
            <div class="right-infobottom">
              <div class="right-price">{{ item.price ? `￥${item.price}` : '价格待定' }}</div>
              <div>
                <span>{{fomateDate(item.date)}}</span>
                <span class="weeek" :class="colorClass(item.signUpStatus)">{{item.signUpStatus}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="zhanwu" v-show="pageArray.length === 0 && !loading">暂无信息 , 敬请期待</div>

        <!--当长度余数为2、3的时候，填充布局-->
        <template v-if="afterLength">
          <div class="between-after" v-for="(item,index) in afterLength"></div>
        </template>
      </div>

      <!-- </transition> -->
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNumber"
          :page-size="20"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDate } from "@/util/util.js";
import axios from "axios";
export default {
  name: "activityIndex",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      navArray: ["周边多天", "周边一天", "国内线路", "国外线路"],
      searchVal: "",
      pageArray: [],
      bannerArray: "",
      // lineIconArray: [],
      nav: 0,

      loading: false,
      bannerLoading: false,
    };
  },
  components: {
    heads,
    homeFoots,
    banners,
  },
  computed: {
    lineIconArray() {
      return this.$store.state.lineIconArray;
    },
    afterLength() {
      //填充元素的长度
      const num = this.pageArray.length % 4;
      switch (num) {
        case 2:
        case 3:
          return 4 - num;
          break;
        default:
          return 0;
          break;
      }
    },
    colorClass(status){
      return function(status){
        switch (status) {
          case '报名中':
            return 'green'
            break;
          case '已成行':
            return 'orange'
            break;
          case '已满员':
            return 'red'
            break;
        }
      }
    }
  },
  methods: {
    fomateDate,
    //轮播
    getBanner() {
      axios
        .get(
          // `/mobile/marquee/get.jhtml?typeName=%25e9%25a6%2596%25e9%25a1%25b5&r=0.1343166060543488`
          "/mobile/marquee/get/3.jhtml"
        )
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.bannerArray = res.data.output;
          } else {
            this.$message({
              message: "系统繁忙，请稍后再试~",
              type: "error",
              duration: 1500,
              center: true,
            });
          }
          this.bannerLoading = false;
        });
    },
    toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        query: { id: id },
      });
    },
    handleCurrentChange(val) {
      this.getActivity(this.nav);
    },
    handleSizeChange(val) {
      console.log("当前页:" + val);
    },
    getNav(id) {
      this.pageArray = [];
      this.pageNumber = 1;
      this.total = 0;
      this.nav = id;
      // this.$router.push({ path: `/activityIndex/${index}` });

      //出现loading
      this.loading = true;

      this.getActivity(id);
    },
    getActivity(id) {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: 20,
        lineIconId: id,
      };
      axios
        .get(`/mobile/line/lineList.jhtml`, {
          params,
        })
        .then((res) => {
          if (res.data.success) {
            this.pageArray = res.data.returnValue.lineList;
            this.total = res.data.returnValue.total;
            //关闭loading
            this.loading = false;
          }
        });
    },
    // lineIconList() {
    //   axios.get(`/mobile/line/lineIconList.jhtml`).then(res => {
    //     if (res.data.success) {
    //       this.lineIconArray = res.data.returnValue;
    //       this.nav = this.lineIconArray[0].id;
    //       this.getActivity(this.lineIconArray[0].id);
    //     }
    //   });
    // }
  },
  mounted() {
    this.bannerLoading = true;
    this.getBanner();
    if (this.lineIconArray > 0) {
      for (let i = 0; i < this.lineIconArray.length; i++) {
        if (this.lineIconArray[i].iconLinkStatus === 0) {
          this.nav = this.lineIconArray[i].id;
          this.getActivity(this.lineIconArray[i].id);
          return;
        }
      }
    }
    // this.getActivity();
    // this.lineIconList();
  },
  created() {
    // this.getActivity(this.nav);
    this.getNav(this.lineIconArray[0].id);
  },
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
  /* text-align: left; */
}
/* box-shadow: 0px 0px 10px #aaaaaa; */

.container {
  text-align: left;
  margin-bottom: 20px;
}
.ban-img {
  width: 100%;
  height: 100%;
}
.textnav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  margin-top: 30px;
  padding: 0 80px;
  box-sizing: border-box;
}
.textnav > span {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.textnav > span:hover {
  background-color: #60f0af;
  color: #000000;
  font-weight: bold;
  border-radius: 20px;
  border: 1px solid #60f0af;
  /* color: #007741;
  border-bottom: 2px solid #007741; */
}
.nac-active {
  background-color: #007741;
  color: #ffffff;
  font-weight: bold;
  border-radius: 20px;
  border: 1px solid #007741;
  /* border-bottom: 2px solid #007741; */
}
.nac{
  border-radius: 20px;
  border: 1px solid ;
  border-color:#ffffff #ffffff  #0000 #ffffff;
}
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 350px;
}
.rotation-left {
  position: relative;
  width: 65%;
  height: 420px;
  margin-bottom: 20px;
}

.label {
  padding: 6px 12px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.8);
  line-height: 40px;
}
.label-text {
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #ffffff;
}
.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}
.right-infobottom {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  font-size: 12px;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  box-sizing: border-box;
}
.weeek {
  display: inline-block;
  margin-left: 8px;
  background: #007640;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  cursor: pointer;
}
.zhanwu {
  padding: 20px 0;
  font-size: 24px;
  width: 100%;
  text-align: center;
  color: #999;
}
.rotation-right {
  position: relative;
  width: 22%;
  height: 340px;
  background: #faf7f7;
  padding-bottom: 41px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 10px;
  /* margin-right: 20px; */
}
.between-after {
  position: relative;
  width: 22%;
  height: 340px;
  padding-bottom: 41px;
  box-sizing: border-box;
  margin-bottom: 10px;
  /* margin-right: 20px; */
}
.rotation-right:hover .right-img {
  transform: scale(1.2);
}
.rotation-right:hover {
  box-shadow: 0px 0px 10px #aaaaaa;
}
.padd-info {
  padding: 0 6px;
  box-sizing: border-box;
}
.trans-img {
  width: 100%;
  height: 60%;
  overflow: hidden;
}
.right-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
/* .right-img:hover {
  transform: scale(1.2);
} */
.right-infoitem {
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  line-height: 24px;
  height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 8px;
  position: relative;
}
/* .right-infoitem::after{
  content:"...";
  position:absolute;
  right: 0;
  top: 2px;
  transform: translateY(100%);
  padding-right: 11px;
  background: #faf7f7;
}  */
.info-describe {
  color: #676767;
  line-height: 22px;
  font-size: 14px;
  margin-top: 10px;
  width: 100%;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* position:relative; */
}
/* .info-describe::after{
  content:"...";
  position:absolute;
}  */
.right-price {
  font-size: 20px;
  font-weight: bold;
  color: #f07621;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* .textnav > .commonTabStyle{
  padding-bottom: 5px;
} */
.green {
  background: #007640;
}
.orange {
  background: #ff6c00;
}
.red {
  background: rgb(211, 23, 23);
}
</style>



// WEBPACK FOOTER //
// src/components/activityview/activityIndex.vue